import * as firebase from "firebase/app";

import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

firebase.initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
});

export default firebase;
export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const storage = firebase.storage();

// Analytics is only used for user-action events (sign in, theme change, etc.),
// never during initial load, so defer loading the firebase/analytics module
// until the first event is logged. This keeps it out of the initial bundle.
// A failure to load analytics is intentionally swallowed — it must never
// affect the user-facing action that triggered the event.
let analyticsInstance = null;
let analyticsLoader = null;

export const analytics = {
  logEvent(...args) {
    if (analyticsInstance) {
      analyticsInstance.logEvent(...args);
      return;
    }

    if (!analyticsLoader) {
      analyticsLoader = import("firebase/analytics").then(() => {
        analyticsInstance = firebase.analytics();
      });
    }

    analyticsLoader.then(() => analyticsInstance.logEvent(...args)).catch(() => {});
  },
};
